module.exports = ".address-bar {\n  padding-top: 10px;\n  padding-bottom: 10px; }\n"